import React, { useCallback, useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import useGetInstagramAccounts from '../../../../../../hooks/instagramAccountsHooks/useGetInstagramAccounts'

import {
  accessibleSocialPagesSelector,
  facebookPageAccessTokensSelector,
  facebookPagesLeadGenFormsSelector
} from '../../../../../../modules/selectors/socialAccounts'
import { getFacebookPagesLeadGenForms } from '../../../../../../modules/actions/socialAccounts'

import { FB_PAGE_CHOICE, INSTA_ACCOUNT_CHOICE, LEAD_GEN_FORM, NAME } from '../../../fields'
import useStyles from './styles'

const NameAndPageSectionPreview = ({ adValues }) => {
  const classes = useStyles()
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const facebookPages = useSelector(accessibleSocialPagesSelector)

  const pageId = adValues[FB_PAGE_CHOICE]
  const page = facebookPages.find(page => page['external_id'] === pageId)
  const pageName = page && page.name
  const selectedLeadGenForm = adValues[LEAD_GEN_FORM]

  console.log('selectedLeadGenForm', selectedLeadGenForm)

  const { selectedInstagramAccounts } = useGetInstagramAccounts(adValues[FB_PAGE_CHOICE])
  const { [pageId]: selectedPageTokenData } = useSelector(facebookPageAccessTokensSelector)
  const facebookPageAccessToken = selectedPageTokenData?.token
  const facebookPagesLeadGenForms = useSelector(facebookPagesLeadGenFormsSelector)

  const leadGenFormName = useMemo(
    () => facebookPagesLeadGenForms.find(form => form.id === selectedLeadGenForm)?.name,
    [selectedLeadGenForm, facebookPagesLeadGenForms]
  )

  const { results: instagramAccounts } = selectedInstagramAccounts

  const instagramAccountId = adValues[INSTA_ACCOUNT_CHOICE]
  const instagramAccount = instagramAccounts.find(account => account.id === instagramAccountId)
  const instagramAccountName = instagramAccount && instagramAccount.username

  const getLeadGenFormsHandler = useCallback(() => {
    dispatch(
      getFacebookPagesLeadGenForms({
        id: pageId,
        page_access_token: facebookPageAccessToken
      })
    )
  }, [dispatch, pageId, facebookPageAccessToken])

  useEffect(() => {
    if (selectedLeadGenForm && pageId && facebookPageAccessToken) {
      getLeadGenFormsHandler()
    }
  }, [getLeadGenFormsHandler, selectedLeadGenForm, pageId, facebookPageAccessToken])

  return (
    <p>
      <span>
        <b>{t('Name:')}</b> <span className={classes.adName}>{adValues[NAME]}</span>
      </span>

      {pageName && (
        <span>
          <b>{t('Facebook Page:')}</b> {pageName}
        </span>
      )}

      {instagramAccountName && (
        <span>
          <b>{t('Instagram Account:')}</b> {instagramAccountName}
        </span>
      )}

      {leadGenFormName && (
        <span>
          <b>{t('Lead Gen Form:')}</b> {leadGenFormName}
        </span>
      )}
    </p>
  )
}

export default NameAndPageSectionPreview
